package com.ives.modules.roi;

import js.html.KeyboardEvent;

import com.er453r.hxcompo.Component;

import com.ives.components.popup.Popup;

class ROIPopup extends Component{
	private var listener:Bool->?String->Void;

	public function new(listener:Bool->?String->Void){
		this.listener = listener;

		on(ok, "click", onOK);
		on(cancel, "click", onCancel);
		on(description, "keyup", onKeyUp);
	}

	private function close(){
		dispatch(Popup.CLOSE);
	}

	private function onKeyUp(event:KeyboardEvent){
		if(event.keyCode == KeyboardEvent.DOM_VK_RETURN)
			onOK();
	}

	private function onOK(){
		listener(true, description.value);

		close();
	}

	private function onCancel(){
		listener(false);

		close();
	}

	private function onClose(){
		listener(false);
	}

	public function open(){
		new Popup(this).open("#viewer", onClose);

		description.value = "";
		description.focus();
	}
}
